import { render, staticRenderFns } from "./scheduled-settings.vue?vue&type=template&id=65b1e8b2&scoped=true"
import script from "./scheduled-settings.vue?vue&type=script&lang=js"
export * from "./scheduled-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b1e8b2",
  null
  
)

export default component.exports